import { create } from 'zustand';

// No persist — session memory only

export type StreamErrorCode =
  | 'model_access_denied'
  | 'rate_limited'
  | 'context_too_long'
  | 'inactivity_timeout'
  | 'upstream_error'
  | 'build_failed';

export interface StreamError {
  code: StreamErrorCode;
  /** User-facing message — safe to display directly. */
  reason: string;
  /** Raw technical detail — for logging only, never shown as-is. */
  detail: string;
}

interface ChatState {
  panelOpen: boolean;
  activeSessionId: string | null;
  streamingMessageIds: Set<string>;
  streamError: StreamError | null;
  togglePanel: () => void;
  setPanelOpen: (open: boolean) => void;
  setActiveSession: (id: string | null) => void;
  addStreamingMessage: (id: string) => void;
  removeStreamingMessage: (id: string) => void;
  setStreamError: (error: StreamError | null) => void;
}

export const useChatSessionStore = create<ChatState>()((set) => ({
  panelOpen: false,
  activeSessionId: null,
  streamingMessageIds: new Set(),
  streamError: null,
  togglePanel: () => set((s) => ({ panelOpen: !s.panelOpen })),
  setPanelOpen: (panelOpen) => set({ panelOpen }),
  setActiveSession: (activeSessionId) => set({ activeSessionId }),
  addStreamingMessage: (id) =>
    set((s) => ({ streamingMessageIds: new Set([...s.streamingMessageIds, id]) })),
  removeStreamingMessage: (id) =>
    set((s) => {
      const next = new Set(s.streamingMessageIds);
      next.delete(id);
      return { streamingMessageIds: next };
    }),
  setStreamError: (streamError) => set({ streamError }),
}));
